import { MouseEvent } from 'react';
import { Button, message, Space } from 'antd';
import { useRouter } from 'next/router';

import styles from './GoToBackButton.module.css';
import classNames from 'classnames/bind';
import useTranslation from 'next-translate/useTranslation';

const cx = classNames.bind(styles);

interface IGoToBackButton {
  onClick?: () => void;
}

function GoToBackButton({ onClick }: IGoToBackButton) {
  const router = useRouter();

  const copyUrl = () => {
    navigator.clipboard
      .writeText(window.location.href)
      .then(() => message.success(t('copy-link')))
      .catch(() => message.error(t('copy-link-error')));
  };

  const { t } = useTranslation('common');
  return (
    <Space size={'large'}>
      <Button
        className={cx('button')}
        id="list-btn"
        type="default"
        shape="round"
        onClick={onClick ? onClick : () => router.back()}
      >
        {t('go-to-list')}
      </Button>
      <Button
        className={cx('button')}
        id="share-btn"
        type="default"
        shape="round"
        onClick={copyUrl}
      >
        {t('share')}
      </Button>
    </Space>
  );
}

export default GoToBackButton;
